import "./Home.module.css";
import Header from "../../reusable_sections/Header";
import Footer from "../../reusable_sections/Footer";
import ModernDentalExcellence from "./sections/ModernDentalExcellence";
import ConsultingPhilosophy from "./sections/ConsultingPhilosophy";
import OurSpecializedCare from "./sections/OurSpecializedCare";
import Testimonials from "./sections/Testimonials";
import SecureYourConsultationToday from "./sections/SecureYourConsultationToday";
import FindOurClinic from "./sections/FindOurClinic";
import InstantMissedCallAlerts from "./sections/InstantMissedCallAlerts";
import ModernMeetup from "./sections/ModernMeetup";
import Banner from "./sections/Banner";
export default function HomePage() {
  return <div>
      <Header />
      <ModernDentalExcellence />
      <OurSpecializedCare />
      <InstantMissedCallAlerts />
      <ConsultingPhilosophy />
      <ModernMeetup />
      <Testimonials />
      <Banner />
      <SecureYourConsultationToday />
      <FindOurClinic />
      <Footer />
    </div>;
}